export const aboutUsContent = {
    title: 'About Us',
    hero: {
        headline: 'Built by Teachers, for Teachers',
        subheadline: 'Saige was born from 6+ years of lesson-planning grind. We believe teachers deserve tools that respect their expertise and give them their evenings back.',
    },
    sections: [
        { 
            heading: 'The Classroom Origin', 
            body: "Saige didn't start in a boardroom; it started in a high school classroom. Our founder was tired of spending Sunday nights copying and pasting TEKS into rigid lesson plan templates. What began as a simple script built to survive the school year grew into a specialized lesson engine that understands real constraints—like 45-minute bell schedules and unexpected fire drills." 
        },
        { 
            heading: 'Amplifying, Not Replacing', 
            body: 'AI should amplify your expertise, not replace it. Every lesson Saige generates is a starting point—fully editable and fully yours. We give you a solid foundation so you can spend less time formatting and more time teaching.' 
        },
        { 
            heading: 'Privacy First & FERPA-Aligned', 
            body: 'Student privacy is non-negotiable. Saige is designed to be FERPA-aligned from the ground up. Student names are never sent to AI models, and all student-facing features use anonymization to ensure safety.' 
        },
    ],
    cta: { text: 'Ready to reclaim your weekends?', button_label: 'Get Started for Free' },
};

export const productContent = {
    title: 'Product',
    hero: {
        headline: 'Lesson Planning, Reimagined',
        subheadline: 'Generate standards-aligned, differentiated lesson plans tailored to your curriculum in under 60 seconds.',
    },
    proofSection: [
        {
            step: 'Step 1',
            title: 'Set Your Context',
            description: 'Tell Saige your grade, subject, and standard (e.g., TEKS or Common Core).'
        },
        {
            step: 'Step 2',
            title: 'Generate the Foundation',
            description: 'In seconds, get a comprehensive lesson including a bell ringer, direct teach activities, differentiation strategies, and an exit ticket.'
        },
        {
            step: 'Step 3',
            title: 'Teach and Project',
            description: 'Use the Classroom Board to project your agenda and activities directly to your students, or export to PDF/PowerPoint.'
        }
    ],
    sections: [
        { heading: 'Standards Alignment', body: 'Mapped to your state standards and pacing guides. Saige understands scope and sequence, keeping your lessons on pace.' },
        { heading: 'Built-In Differentiation', body: 'Pre-scaffolded activities for ELL, IEP/504, and gifted learners. Reach every student in your classroom effortlessly.' },
        { heading: 'Multi-Day Planning', body: 'Plan an entire week in one click. Generate sequential lessons with spiraled review and logical progression.' },
        { heading: 'Classroom Board', body: 'Project your lesson directly from Saige. No secondary slide deck required. Display your objective and activities in a clean layout.' },
    ],
    cta: { text: 'See it in action', button_label: 'Try Saige Now' },
};
